import { workspaceRefusalMessage } from '../workspaces/workspaceDisplay';

export const TURN_REFUSAL_MESSAGE_ID = 'reasoning-error';

export interface TurnRefusalInput {
  error: string | null;
  workspaceRefusal: string | null;
  isReasoning: boolean;
}

// (workspace_state ADR-028, agents ADR-96511)
export function turnRefusalRow(input: TurnRefusalInput): { id: string; content: string } | null {
  if (input.isReasoning || !input.workspaceRefusal || !input.error) return null;
  return {
    id: TURN_REFUSAL_MESSAGE_ID,
    content: workspaceRefusalMessage(input.workspaceRefusal, input.error),
  };
}
